export default "__VITE_ASSET__DSUtBogx__"